export enum CalloutAccess {
  Member = 'member',
  Guest = 'guest',
  Anonymous = 'anonymous',
  OnlyAnonymous = 'only-anonymous',
}
